import { useState } from 'react'
import { CopyIcon, Tooltip, IconButton } from '@buffer-mono/popcorn'

import { useAppSelector } from '~publish/legacy/store'

import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'

import styles from './CopyButton.module.css'

function CopyButton({
  disabled,
}: {
  disabled: boolean | undefined
}): JSX.Element {
  const [isCopied, setIsCopied] = useState(false)
  const { contentGenerationResults } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  function handleFeedbackOnClick(): void {
    setIsCopied(true)
    // Reset state in case user clicks copy button again
    setTimeout(() => {
      setIsCopied(false)
    }, 1500)
  }

  function handleCopyClick(): void {
    void navigator.clipboard.writeText(contentGenerationResults[0])
    handleFeedbackOnClick()
  }

  return (
    <div className={`${styles.wrapper} ${disabled ? styles.disabled : ''}`}>
      {isCopied && <div className={styles.toast}>Copied!</div>}
      <Tooltip content="Copy text" side="top">
        <IconButton
          label="Copy text"
          onClick={handleCopyClick}
          disabled={disabled}
          size="small"
          variant="tertiary"
        >
          <CopyIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export { CopyButton }
